import { render, staticRenderFns } from "./detailedList.vue?vue&type=template&id=0a51a416&scoped=true&"
import script from "./detailedList.vue?vue&type=script&lang=js&"
export * from "./detailedList.vue?vue&type=script&lang=js&"
import style0 from "./detailedList.vue?vue&type=style&index=0&id=0a51a416&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a51a416",
  null
  
)

export default component.exports